import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRoleSiteFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		roleId?: any;
		siteId?: any;
}

export class RoleSiteFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public roleId: IEntityModelField = { name: "roleId", displayName: "Role Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public siteId: IEntityModelField = { name: "siteId", displayName: "Site Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.siteId);
	}
}

export class RoleSiteDTO implements IEntityModel {
	protected roleSiteName: string = "RoleSiteModel";
	protected roleSiteKeyField: string = "id";
	protected roleSiteDisplayName: string = "Role Site|Role Sites";
	protected roleSiteFields = new RoleSiteFields();
	public get name(): string { return this.roleSiteName };
	public get keyField(): string { return this.roleSiteKeyField };
	public get displayName(): string { return this.roleSiteDisplayName };
	public get fields(): RoleSiteFields { return this.roleSiteFields };

	constructor() {};
}
